import { Injectable } from "@angular/core";

import { ChartOptions } from "chart.js";

@Injectable({
  providedIn: "root",
})
export class ChartOptionsService {
  documentStyle = getComputedStyle(document.documentElement);
  surfaceColor = this.documentStyle.getPropertyValue("--surface-300");
  firstBarColor = this.documentStyle.getPropertyValue("--blue-400");
  getChartOptions(chartType: string): ChartOptions<"bar"> {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
      delay: (context) => {
        if (context.type === "data" && context.mode === "default") {
        return context.dataIndex * 50;
        }
        return 0;
      },
      },
      elements: {
      bar: {
        backgroundColor: this.getChartColors().map((color) => color.backgroundColor),
        borderRadius: 15,
        borderWidth: 0,
      },
      },
      plugins: {
      legend: {
        display: false,
      },
      },
      scales: {
      x: {
        ticks: {
        display: true,
        },
        grid: {
        display: false,
        },
        border: {
        display: false,
        },
      },
      y: {
        ticks: {
        display: true,
        },
        grid: {
        drawTicks: true,
        color: (context) => (context.tick.value === 0 ? this.surfaceColor : "transparent"),
        },
        border: {
        display: false,
        },
        title: {
        display: true,
        text: chartType === "vmax" || chartType === "proj" || chartType === "imax" ? "Hours" : "Days",
        },
      },
      },
    };
  }

  getChartColors(): { backgroundColor: string }[] {
    return [{ backgroundColor: this.firstBarColor }];
  }
}
